/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1PersonIdTeacherThumbnail202,
  DeleteApiV1PersonIdTeacherThumbnail401,
  DeleteApiV1PersonIdTeacherThumbnail404,
  DeleteApiV1PersonIdTeacherThumbnail500,
  DeleteApiV1PersonIdTeacherThumbnailMutationResponse,
  DeleteApiV1PersonIdTeacherThumbnailPathParams,
} from "../../types/personTeacherController/DeleteApiV1PersonIdTeacherThumbnail.ts";

export const deleteApiV1PersonIdTeacherThumbnailPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1PersonIdTeacherThumbnailPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1PersonIdTeacherThumbnail202Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdTeacherThumbnail202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1PersonIdTeacherThumbnail401Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdTeacherThumbnail401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1PersonIdTeacherThumbnail404Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdTeacherThumbnail404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1PersonIdTeacherThumbnail500Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdTeacherThumbnail500>;

export const deleteApiV1PersonIdTeacherThumbnailMutationResponseSchema = z.lazy(
  () => deleteApiV1PersonIdTeacherThumbnail202Schema,
) as unknown as ToZod<DeleteApiV1PersonIdTeacherThumbnailMutationResponse>;
